/**
 * Builds flat list data for league-by-date FlashList: date headers and game rows.
 */

import type { DateSection } from './groupGamesByDate.helper';
import type { LeagueDateListItem } from '../types/gameResults.types';

export interface LeagueDateFlatListResult {
  data: LeagueDateListItem[];
  stickyHeaderIndices: number[];
}

/**
 * Flatten date sections into a single array for FlashList with getItemType.
 * Sticky indices point to date header rows (excluding the last so the final section can scroll past).
 */
export function buildLeagueDateFlatList(
  sections: DateSection[]
): LeagueDateFlatListResult {
  const data: LeagueDateListItem[] = [];
  const stickyHeaderIndices: number[] = [];

  for (const section of sections) {
    const headerIndex = data.length;
    data.push({
      type: 'dateHeader',
      title: section.title,
      dateKey: section.dateKey,
    });
    stickyHeaderIndices.push(headerIndex);

    const games = section.data;
    games.forEach((game, i) => {
      data.push({
        type: 'game',
        game,
        isLastInSection: i === games.length - 1,
      });
    });
    data.push({ type: 'sectionFooter', dateKey: section.dateKey });
  }

  return {
    data,
    stickyHeaderIndices:
      stickyHeaderIndices.length <= 1
        ? stickyHeaderIndices
        : stickyHeaderIndices.slice(0, -1),
  };
}
